<div class="full column">
  <ng-container *ngIf="dimensionMapping.length > 0; else ShowEmptyMessage">
    <ng-container *ngIf="displayHelpText">
      <div class="lm-dimensions-mapping-help-container">
        <svg class="icon icon-info" style="top: 0px !important" focusable="false" aria-hidden="true" role="presentation">
          <use [attr.xlink:href]="'#icon-info'"></use>
        </svg>
        <p style="flex-:1 wrap">{{helpText}}</p>
      </div>
    </ng-container>
    <ng-container *ngFor="let dimension of dimensionMapping">
      <lm-cube-dimension-row
          [cubeBusClass]="cubeBusClass"
          [dimension]="dimension"
          [structures]="structures"
          [hasReportingBasis]="hasReportingBasis"
          [topNodeBaseValue]="topNodeBaseValues ? topNodeBaseValues[dimension.id] : undefined"
      >
      </lm-cube-dimension-row>
    </ng-container>
  </ng-container>
  <ng-template #ShowEmptyMessage>
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  </ng-template>
</div>
